// src/pages/Produtos/profiles/index.js
import { baseDefaults } from './defaults';

import { produtoProfile } from './produto';
import { vtrProfile } from './vtr';
import { imovelProfile } from './imovel';
import { materiaPrimaProfile } from './materiaPrima';

import { bobinaProfile } from './bobina';

// use as mesmas utils do movimento (mergeAlways / mergeIfEmpty)
import { mergeAlways, mergeIfEmpty } from '../../../../boot/utils';

const profilesByCategoria = {
    produto: produtoProfile,
    vtr: vtrProfile,
    veiculo: vtrProfile,
    imovel: imovelProfile,
    'materia-prima': materiaPrimaProfile,
    materiaprima: materiaPrimaProfile,
    bobina: bobinaProfile,
};

export function resolveProdutoProfile({ categoria }) {
    const key = String(categoria || 'produto')
        .toLowerCase()
        .trim();
    const selected = profilesByCategoria[key] || produtoProfile;

    // merge “igual Movimento”: base -> override
    // aqui você pode decidir mergeIfEmpty/mergeAlways por seção
    let out = baseDefaults;

    // tabs / uiTabs / function / parametros: normalmente mergeAlways
    out = mergeAlways(out, selected);

    // se você quiser: defaultsProduto não destruir o que veio do backend:
    if (selected?.parametros?.defaultsProduto) {
        out = mergeAlways(out, {
            parametros: {
                defaultsProduto: mergeAlways(baseDefaults.parametros.defaultsProduto, selected.parametros.defaultsProduto),
            },
        });
    }

    return out;
}

/**
 * Sanitiza o objeto do backend para não carregar/propagar filhos inúteis
 */
export function sanitizeProdutoByProfile({ raw, profile }) {
    const keepBase = profile?.parametros?.sanitize?.keepBase || baseDefaults.parametros.sanitize.keepBase;
    const keepChildren = profile?.parametros?.sanitize?.keepChildren || [];

    const keep = new Set(keepBase);

    const out = {};
    Object.keys(raw || {}).forEach((k) => {
        if (keep.has(k)) out[k] = raw[k];
    });

    // padroniza nomes de filhos (se teu back devolve "produtoImagem", você converte aqui)
    // ajuste conforme o seu retorno real
    const normalizeChildren = (obj) => {
        // imagens
        if (obj?.produtoImagem && !obj?.produtoImagens) obj.produtoImagens = obj.produtoImagem;
        return obj;
    };

    normalizeChildren(raw);

    // mantém somente filhos permitidos
    keepChildren.forEach((childKey) => {
        if (raw?.[childKey] !== undefined) out[childKey] = raw[childKey];
    });

    // defaults seguros p/ evitar undefined em telas
    if (keepChildren.includes('produtoEmbalagens')) out.produtoEmbalagens = out.produtoEmbalagens || [];
    if (keepChildren.includes('produtoImagens')) out.produtoImagens = out.produtoImagens || [];
    if (keepChildren.includes('produtoBens')) out.produtoBens = out.produtoBens || null;

    return out;
}

/**
 * Boot (preenche default só em novo cadastro) — igual Movimento
 */
export function applyProdutoBoot({ prev, categoria }) {
    const profile = resolveProdutoProfile({ categoria });

    // só preenche vazio (não destrói)
    const patch = profile?.parametros?.defaultsProduto || {};
    return mergeIfEmpty(prev, patch);
}
